import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PATHS } from "configs/routeConfig";
import { Dropdown } from "react-bootstrap";
import { getTimeDifference, organizeNotifications } from "utils/functions";
import { formatDateTime } from "utils/functions";
import PropTypes from "prop-types";
import { useProfileHook } from "hooks/profile/useProfileHook";
import Loader from "components/loader/Loader";
function NotificationBox({ setToggle }) {
  const navigate = useNavigate();

  const {
    getNotificationsList,
    getNotificationsListData,
    isGetNotificationsListUninitialized,
    updateNotificationStatus,
    globalConfigData,
  } = useProfileHook();

  useEffect(() => {
    const fetchNotificationsListAsync = async () => {
      await getNotificationsList({ page: 1, pageSize: 10, searchText: "" });
    };
    fetchNotificationsListAsync();
  }, [isGetNotificationsListUninitialized]);

  //navigation according notification
  const handleNotificationClick = async (notification) => {
    const navigationRoute = JSON.parse(notification?.data);
    if (navigationRoute?.type === "assessment" || navigationRoute?.type === "wound") {
      navigate(`/${PATHS.WOUND_LISTING}/${navigationRoute?.type}/${navigationRoute?._id}`);
    } else if (navigationRoute?.type === "patient") {
      navigate(`${PATHS.USER}/${PATHS.USER_LIST}/${"view"}/${navigationRoute?._id}`);
    }
    if (!notification.isRead) {
      // Extract the ID and update the state
      const updatedIds = [notification._id]; // Update logic as needed
      await updateNotificationStatus({
        ids: updatedIds,
        isRead: true,
        markAll: false,
      });
    }
    setToggle(false);
  };
  const groupedNotifications = organizeNotifications(
    getNotificationsListData?.data?.slice(0, 5) || [],
    globalConfigData
  );
  return (
    <Dropdown autoClose="outside" className="dropdown-menu ctm-dropdown dropdown-lg shadow onhover-show-div show">
      <div className="dropdown-header">
        <span className="dropdown-title">Notification</span>
      </div>
      {!isGetNotificationsListUninitialized ? (
        <ul className="list-unstyled dropdown-list">
          {groupedNotifications?.length > 0 ? (
            groupedNotifications?.map((group, index) => {
              const [section, notifications] = Object.entries(group)[0]; // Extract key-value pair
              return (
                <>
                  <li className="notification-header">{section}</li>
                  {notifications?.map((notification) => (
                    <li
                      key={notification?._id}
                      className="notification"
                      onClick={() => handleNotificationClick(notification)}
                    >
                      <div className="notification-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path
                            d="M6 8.5H18M16 12.5H6M3 16V5C3 4.44772 3.44772 4 4 4H20C20.5523 4 21 4.44772 21 5V16C21 16.5523 20.5523 17 20 17H6.75L3.16247 19.87C3.09699 19.9224 3 19.8758 3 19.7919V16Z"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                      <div className="notification-content w-100 me-8">
                        <h6 className="notification-title">{notification?.title}</h6>
                        <p className="notification-message line-clamp-2">{notification?.body}</p>
                      </div>
                      <div className="notification-status d-flex justify-content-end w-25">
                        <span className="notification-time">
                          {section === "Today"
                            ? getTimeDifference(notification?.createdAt)
                            : formatDateTime(notification?.createdAt, globalConfigData)}
                        </span>

                        {!notification?.isRead ? (
                          <span className="notification-badge"></span>
                        ) : (
                          <span className="notification-badge notification-empty"></span>
                        )}
                      </div>
                    </li>
                  ))}
                </>
              );
            })
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <p className="p-10">Data Not Found</p>
            </div>
          )}
        </ul>
      ) : (
        <div className="notification-loader">
          <Loader className="my-12" />
        </div>
      )}
      {!isGetNotificationsListUninitialized && groupedNotifications?.length > 0 && (
        <div
          className="w-100 text-center see-all cursor-pointer"
          onClick={() => {
            setToggle(false);
            navigate(`/${PATHS.NOTIFICATIONS}`);
          }}
        >
          See All Notifications
        </div>
      )}
    </Dropdown>
  );
}

NotificationBox.propTypes = {
  setToggle: PropTypes.func.isRequired,
};

export default NotificationBox;
